import axios from "axios";
const URLS = "https://plasticsmartcities.wwf.id/aksi/api";
var TOKEN = sessionStorage.getItem('token');


export default {
   actions: {
      setToken(data){
         TOKEN = data
      },
      register(data) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .post(URLS + `/v1/auth/register/client`, data)
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      login(data) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .post(URLS + `/v1/auth/login`, data)
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
         } catch (error) {
            reject(error);
         }
         });
      },
      get_users() {
         return new Promise(async (resolve, reject) => {
            try {
            await axios
               .get(URLS + `/v1/users/profile`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     "Content-Type": "application/json",
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      put_profile(data) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .put(URLS + `/v1/client/profile`, data, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
         } catch (error) {
            reject(error);
         }
         });
      },

      put_password(data) {
         return new Promise((resolve, reject) => {
         try {
            axios
               .post(URLS + `/v1/users/change-password`, data, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
         } catch (error) {
            reject(error);
         }
         });
      },
   },
};


